<script>
/* eslint-disable */
export default {
    props: ['item', 'circuit'],
    data(){
        return {
            changed: false,
            editMode: false,
            instruction: this.item ? this.item.instruction : '',
            selected: false,
        }
    },
    watch: {
        item(val){
            this.instruction = val.instruction
        },
        instruction(){
            this.changed = true
        },
        selected(){
            console.log('selected', this.item.id)
            if (this.selected) {
                this.$store.commit('scripts/pushSelectedMoves', this.item.id)
            }
            else {
                this.$store.commit('scripts/popSelectedMoves', this.item.id)
            }
        }
    },
    methods: {
        save(){
            this.$store.dispatch('scripts/updateItem', {
                instruction: this.instruction,
                confirmed: true,
                id: this.item.id,
                type: 'instruction'
            })            
            this.$store.commit('scripts/clearSelectedMoves')
            setTimeout(() => { 
                this.$store.dispatch(
                `${this.currentType}/getActivity`,
                    this.$route.params.id
                );
                setTimeout(() => {  this.$store.commit(`${this.currentType}/setTabStatus`, false);}, 1000);         
            }, 2000);
        },
        cancel(){
            this.$store.dispatch('scripts/removeItem', this.item.id)
            this.$store.dispatch('scripts/removeMove', this.item.id)
        },
        edit(){
            this.$store.dispatch('scripts/updateItemNoSync', {
                confirmed: false,
                id: this.item.id,
            })
            this.changed = true
            this.editMode = true
        },
        deleteItem(){
            this.$store.dispatch('scripts/removeItem', this.item.id)
            this.$store.dispatch('scripts/removeMove', this.item.id)
        }
        
    },
    computed: {
        currentType() {
            const url = this.$route.path.split("/")[1];
            if (this.$route) {
                if (url == "update-warmup" || this.$route.path == "/create-warmup") {
                return "warmups";
                } else if (
                url == "update-stretch-flow" ||
                this.$route.path == "/create-stretch-flow"
                ) {
                return "stretchflows";
                } else if (
                url == "update-workout" ||
                this.$route.path == "/create-workout"
                ) {
                return "workouts";
                }
            }
            return "commons";
        },
    }
}
</script>


<style scoped>
    .selector{
        border-right: 5px solid #333;
    }
    .row{
        min-height: 40px;
        margin:-1px 0 0 0;
    }
    .label{
        text-align: right;
        text-transform: uppercase;
    }
    .input-container{
       background-color: #effdff;
    }
    .input-container .group, .input-container .selector{
       padding-top: 8px;
       padding-bottom: 8px;
    }
    .btn-action-group{
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .btn-action-group .btn-action{
        text-transform: uppercase;
        margin-right: 1rem;
        padding: 0.75rem;
    }
    .script-item{
        font-family: 'Times New Roman', Times, serif;
        display: block;
    }
    .script-item.move-block{
        font-size: 24px;
        color: #000;
        font-weight: bold;
    }
    .script-item.move-block.alt{
        color: #34B362;
    }
    .script-item.note-block{
        font-size: 18px;
        color: #F2711C;
    }
    .script-item.instruction-block{
        font-size: 24px;
        color: #F2711C;
        font-weight: bold;
    }
    .count{
        margin-right: 1.5rem;
    }
    .count{
        margin-right: 1.5rem;
    }   
    .reps-count-mark{
        font-size: 24px;
        font-family: 'Times New Roman', Times, serif;
        font-weight: 600;
    } 
    .label-with-reps{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .reps-box{
        margin-left: 2rem;
    }
    .reps-wrap{
        text-align: right;
    }
    button.icon-only{
        border: 0;
        background-color: transparent;
    }
    .details-wrapper{
        padding-top: 10px;
        padding-bottom: 8px;
    }
</style>
<template>
    <div class="row" v-if="!item || item.type === 'filler'">
        <div class="selector col-md-1">
        </div>
        <div class="col-md-11 ">
        </div>
    </div>
    <div class="row input-container" v-else-if="item && !item.confirmed">
        <div class="selector col-md-1">
        </div>
        <div class="col-md-8 group">
            <div class="row">
                <div class="col-md-2 label pt-1"><label>Instruction</label></div>
                <div class="col-md-10"><b-form-input v-model="instruction" placeholder="Eg.: REMOVE MAT"></b-form-input></div>
            </div>
        </div>
        <div class="col-md-3 btn-action-group">
            <div>
                <b-button size="sm" class="btn-action cancel" @click="cancel()">Cancel</b-button>
                <b-button size="sm" class="btn-action" variant="primary" :disabled="!changed" @click="save()">Save</b-button>
            </div>
        </div>
    </div>
    <div class="row draggable" v-else>
        <div class="selector col-md-1">
           <div class="round">
                <input type="checkbox" :id="'checkbox'+item.id" v-model="selected"/>
                <label :for="'checkbox'+item.id"></label>
          </div>
        </div>
        <div class="col-md-11">
            <div class="d-flex">
                <div class="">
                    <div class="float-left count">
                        
                    </div>
                    <div class="float-left">
                        <span class="instruction-block script-item">{{item ? item.instruction : ''}}</span>
                    </div>
                </div>
                <div class=" label-with-reps" v-if="selected">
                    <button class="icon-only" @click="edit()">
                        <b-icon icon="pencil" font-scale="1.5"></b-icon>
                    </button>
                    <button class="icon-only pl-2" @click="deleteItem()">
                        <b-icon icon="trash" variant="danger" font-scale="1.5"></b-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>